


















































































































































































































































































































































































































































































































































































































































































































































import {Component, mixins, Watch} from "nuxt-property-decorator";
import ProductMixin, {
  IModifierSet,
} from "../../node_modules/sitis-nuxt/lib/mixins/ProductMixin";
import {IAddItemToCartBody} from "../../node_modules/sitis-nuxt/lib/store/modules/cart-store";
import SPage from "~/components/page/SPage.vue";
import PageBreadcrumbs from "~/components/page/PageBreadcrumbs.vue";
import ProductGallery from "~/components/product/ProductGallery.vue";
import ProductPrice from "~/components/product/ProductPrice.vue";
import ProductToCartButton from "~/components/product/ProductToCartButton.vue";
import WishlistButton from "~/components/product/WishlistButton.vue";
import ProductCard from "~/components/product/ProductCard.vue";
import Options from "~/components/product/Options.vue";
import ImageMainProduuctCard from "~/components/product/main-product-card/ImageMainProduuctCard.vue";
import AddToCart from "~/components/product/main-product-card/AddToCart.vue";
import AddToCartV2 from "~/components/product/add-to-cart/AddToCart.vue";
import DescriptionMainProductCard from "~/components/product/main-product-card/DescriptionMainProductCard.vue";
import SectionDescriptionDocuments from "~/components/product/main-product-card/SectionDescriptionDocuments.vue";
import SectionDescriptionDocumentsMobile from "~/components/product/main-product-card/SectionDescriptionDocumentsMobile.vue";
import DescriptionOfCharacteristics from "~/components/product/main-product-card/DescriptionOfCharacteristics.vue";
import Calculator from "~/components/product/Calculator.vue";
import DialogAddressMap from "~/components/product/DialogAddressMap.vue";
import {AppMixin} from "~/node_modules/sitis-nuxt/lib/mixins";
import {CmsMetaMixin} from "~/node_modules/sitis-nuxt/lib/mixins/index";
import {ObserveVisibility} from "vue-observe-visibility";
import ShareLinks from '~/components/product/ShareLinks.vue';
import FastBuyProduct from '~/components/catalog/FastBuyProduct.vue'
import {convertBoolHelper} from "~/helpers/convertBoolHelper";
import {addToCart} from "~/helpers/to-cart";
import {getOgTitle} from "~/helpers/metaHelper";
import {IGetProductParams} from "sitis-nuxt/lib/store/modules/product-store";
import StickyMobileAddToCart from "~/components/product/add-to-cart/StickyMobileAddToCart.vue";

@Component({
  fetch: async function (this: ProductPage) {
    await this.loadProduct();
  },

  head: function (this: ProductPage) {
    return this.getHead();
  },

  asyncData: function (context) {
    const host: string = context?.req?.headers?.host || window?.location.host || "";

    return {
      host
    };
  },

  components: {
    PageBreadcrumbs,
    ProductGallery,
    ProductPrice,
    WishlistButton,
    SPage,
    ProductToCartButton,
    ProductCard,
    ImageMainProduuctCard,
    AddToCart,
    AddToCartV2,
    Options,
    DescriptionMainProductCard,
    SectionDescriptionDocuments,
    SectionDescriptionDocumentsMobile,
    DescriptionOfCharacteristics,
    Calculator,
    DialogAddressMap,
    ShareLinks,
    FastBuyProduct,
    StickyMobileAddToCart,

    DialogSignUpSelection: () => import("~/components/product/DialogSignUpSelection.vue")
  },

  directives: {
    ObserveVisibility,
  },

  mounted: async function (this: ProductPage) {
    window.addEventListener('scroll', this.checkVisibleMobileBuyButton);
    if (this.product?.id) {
      await this.getRichContent();
    }
    await this.$store.commit("products/setSameProducts", []);
    await this.$store.commit("products/setRelatedProducts", []);
    await this.$store.commit("products/setRecentlyProducts", []);
    if (window.innerWidth <= 999) {
      this.showOtherProducts = true;
      this.sameProductsAmount = 9999;
      this.relatedProductsAmount = 9999;
      this.recentlyProductsAmount = 9999;
    }
    const goBackCatalog = this.goBackCatalog.bind(this);
    window.onpopstate = function () {
      goBackCatalog();
      window.onpopstate = null;
    };

    const _slug = (this.$route?.params?.slug || "");
    await this.getSameProducts(_slug);

    await this.$store.dispatch("mindbox/productProductView", this.product);
  },
  destroyed: function (this: ProductPage) {
    window.removeEventListener('scroll', this.checkVisibleMobileBuyButton);
  },

  computed: {
    isNeedBlockInvert() {
      return process.client && window.innerWidth < 999;

    },

    adultInfoLenses: function (this: ProductPage) {
      const infoJSON = this.vars['Взрослые оправы'] || '';
      if (!infoJSON) {
        return {}
      }

      let info = {};

      try{
        info = JSON.parse(infoJSON);
      }catch (e) {
        info = {}
      }

      return info;
    },

    childInfoLenses: function (this: ProductPage) {
      const infoJSON = this.vars['Детские оправы'] || '';
      if (!infoJSON) {
        return {}
      }

      let info = {};

      try{
        info = JSON.parse(infoJSON);
      }catch (e) {
        info = {}
      }

      return info;
    },
    isShowSpecifications: function (this: ProductPage) {
      const variants = this.getVariantsForModifierSet(this.modifierSets?.[0]?.id || 0);

      if (this.$store.state["local-settings"].isJJ) {
        return (variants || []).length > 0
      }

      return Boolean(this.product?.category?.name === 'Контактные линзы' && ((variants || []).length > 0))
    },

    promotion: function (this: ProductPage) {
      const product: any = this.product;
      const promotions = product?.promotions || [];
      return promotions.find((t: any) => Boolean(t?.label))
    },


    // getRefOptions: function (this: ProductPage) {
    //   return {
    //     refOption0: this.$refs.refOption0,
    //     refOption1: this.$refs.refOption1,
    //   }
    // },
  },
  methods: {
    formatPrice(price: number): string {
      return new Intl.NumberFormat("ru-RU").format(price);
    },


    resetOtherProducts: function () {
      console.log('resetOtherProducts')
    },
  }
})
export default class ProductPage extends mixins(ProductMixin, AppMixin) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isShowDescription: boolean = false;
  $toast: any;
  $api: any;
  $vkGoalWr: any;
  sameProductsAmount: number = 4;
  relatedProductsAmount: number = 4;
  recentlyProductsAmount: number = 4;
  typeOfFrames: string = "";
  cmsPageId: number = 0;
  typeEyes: string = "same"; //various
  // showOtherProducts: boolean = false;
  showOtherProducts: boolean = true;
  showReachContent: boolean = false;
  showCmsContent: boolean = false;
  isAddedToCart: boolean = false;
  isProductEmpty: boolean = false;
  isProductEcommerceDetail: boolean = false;
  productTermDelivery: object = {};
  productTermWithoutModification: object = {};
  productAvailability: object = {};
  productAvailabilityAddress: object = {};
  productAvailabilityNames: object = {};
  productAvailabilityQuantities: object = {};
  $cookies: any;
  $customNotification: any;
  $yandexCommerce: any;
  activeStore: object = {};
  $img: any;
  selectedVariants: any = [
    {}
  ];
  host: any = "";
  $scrollTo: any;
  isScrolled: boolean = false;
  fastBuyProduct: number = 0;
  fastBuyProductPayment: string = '';

  initSelected: any = {};
  isInitSelected: boolean = false;

  productPriceModifactions: Object = {};
  isOpenSelectionCasePopup: boolean = false;

  isVisibleMobileBuyButton: boolean = false;



  // sizes: any = {};
  @Watch("$route", {immediate: true})
  onRouteChanged(): void {
  }

  @Watch("product", {immediate: true})
  async onProductChanged(): Promise<void> {
    await this.getRichContent();
    await this.initialProductModification();

    if (!!this.product && !this.isProductEcommerceDetail) {
      this.$yandexCommerce("detail", [this.product]);
      this.isProductEcommerceDetail = true;
    }
  }

  visibilityChanged(isVisible: boolean, entry: any) {
    if (isVisible) {
      this.getRelatedProducts(this.slug);
      this.getRecentlyProducts();
    }
    this.showOtherProducts = isVisible;
  }

  get getResentlyProducts() {
    let recentlyProducts = this.recentlyProducts;
    let currentProduct = this.product;
    return recentlyProducts.filter((t) => t.id !== currentProduct?.id);
  }

  visibilityAfterReachContentChanged(isVisible: boolean, entry: any) {
    this.showReachContent = isVisible;
  }

  visibilityAfterOtherProductsChanged(isVisible: boolean, entry: any) {
    this.showCmsContent = isVisible;
  }

  get isCharacteristicsHas() {
    const sizes: any = this.sizes;
    const isHas = Object.keys(sizes).reduce((prev, current: string) => {
      return prev + Object.keys(sizes[current]).length;
    }, 0);
    return isHas;
  }

  get steBreadСrumbs() {
    let categoriesLink = (this.product?.categories || []).map((item) => item?.slug).join("/");
    if (this.$store.state["local-settings"].isJJ) {
      const additionalCategory: any = [...(this.product?.additionalCategories || [])].pop();
      categoriesLink = ['catalog', additionalCategory?.slug || ""].filter((t) => !!t).join('/')
    }

    const productCharacteristics: any = this.product?.characteristics || [];
    const characteristics = productCharacteristics.find((t: any) => t.name === "Основные")?.characteristics || [];
    const brand = characteristics.find((t: any) => t.slug === "brand")?.values?.[0] || {};

    let breadcrumbs: any;
    breadcrumbs = [
      ...this.breadcrumbs,
      {
        path: `/${categoriesLink}/f/brand=${brand?.slug}`,
        title: brand?.value,
        isClickable: true
      },
      {
        path: `/${this?.product?.url || ''}`,
        title: this.product?.name || '',
      }
    ];

    return breadcrumbs
      .filter((t: any) => !!t.title)
      .filter((t: any) => t.path !== '/catalog')
  }

  get sizes() {
    let sizes = {
      dlinaZaushnika: {},
      shirinaOkulara: {},
      visotaOkulara: {},
      shirinaPerenosya: {},
    };

    const productCharacteristics: any = (this.product?.characteristics || []).find((t) => t?.name === "Основные") || {};
    const characteristics: any = productCharacteristics?.characteristics || [];

    characteristics.map((item: any) => {
      if (item?.name === "Длина заушника") {
        sizes["dlinaZaushnika"] = item;
      }
      if (item?.name === "Ширина окуляра") {
        sizes["shirinaOkulara"] = item;
      }
      if (item?.name === "Высота окуляра") {
        sizes["visotaOkulara"] = item;
      }
      if (item?.name === "Ширина переносья") {
        sizes["shirinaPerenosya"] = item;
      }
    });

    return sizes;
  }

  get isShowButtonMyAcuvue() {
    const isInclude = Boolean(process.env.myAcuvueIncluded || false);
    const isAcuvue = Boolean(this.product?.brand?.name === "ACUVUE");

    return Boolean(isInclude && isAcuvue)
  }

  get isChild() {
    const isProduction = Boolean(process.env.productionNodeEnv || false);

    if (isProduction) {
      return false
    }

    const characteristics = this.product?.characteristics || [];

    if (characteristics.length <= 0) {
      return false
    }

    const child: any = characteristics.find((t) => t.name === 'Пол') || {};

    if (Object.keys(child).length <= 0) {
      return false
    }

    return Boolean((child?.values || []).includes('Детская'));
  }

  get isChildV2() {

    const characteristics = this.product?.characteristics || [];
    if (characteristics.length <= 0) {
      return false
    }

    const child: any = ((characteristics?.[0] || {}).characteristics || []).find((t: any) => t?.name === 'Пол') || {};

    if (Object.keys(child).length <= 0) {
      return false
    }

    return Boolean((child?.values || [])[0].slug === 'detskaya');
  }


  get isNewAddToCart() {
    return true

    const isProductionNodeEnv = Boolean(process.env.productionNodeEnv || false);
    if (!isProductionNodeEnv) {
      return true
    }

    const user = this.$store.state?.user?.user || {};
    if (Object.keys(user).length <= 0) {
      return false
    }

    return [
      "79022658701",
      "79530092506",
    ].includes(user?.username);
  }

  get isProductStocks() {
    const characteristics: any = this.product?.characteristics?.[0]?.characteristics || []
    // const isManufacturerCooperVision: any = Boolean(((characteristics).find((t: any) => t.slug === "manufacturer")?.values || []).find((t: any) => t.slug === "cooper-vision"));
    // if (!!isManufacturerCooperVision) {
    //   return true
    // }

    let allAvaiblesModification = true;
    const productAvailability: any = {...this.productAvailability};

    Object.keys(productAvailability).map((key) => {
      if (!productAvailability[key]) {
        allAvaiblesModification = false
      }
    })

    return allAvaiblesModification
  }

  async toCart(params: any = {}) {
    // const customPopupFlag = 'CUSTOM_POPUP_SHOW' // Договор с бэком, если фраза первая в меседже, то кастомный попап, в админке переменная "Сообщение о запрете MiSight для текста"
    // Если продукт не имеет модификаций
    if (!this.hasModifications) {

      this.$parent.$emit("changeShowDialogLoading", true);

      const item: IAddItemToCartBody = {
        productId: this.product?.id || 0,
        quantity: 1
      };

      const response = await this.putToCart(item).catch((err) => {
        return false
      });

      if (!response) {
        this.$parent.$emit("changeShowDialogLoading", false);

        this.$customNotification.error("Ошибка добавления товара");

        return
      }

      this.isAddedToCart = true;
      await this.$store.dispatch("mindbox/productCartChange");

      this.$yandexCommerce("add", [{
        ...this.product,
        ...item
      }])
      await this.getCart();
      this.$vkGoalWr("AddCard", {}, process.env.vkPixelCode);

      this.$parent.$emit("changeShowDialogLoading", false);

      if (params?.payment === "shares") {
        this.$store.commit("cart-new/changeSelectedPayment", "shares")
        this.$router.push("/cart");
      }
      if (params?.payment === "unitpay") {
        this.$store.commit("cart-new/changeSelectedPayment", "unitpay")
        this.$router.push("/cart");
      }

      return;

    }

    const productVariants = [...(this.product?.variants || [])]
      .filter((t) => !Boolean(['bundles'].includes(t?.name)))

    let isSuccessAll: boolean = true;
    let isAllSelected: Boolean = true;
    const countVariants: Number = productVariants?.length || 0;
    this.selectedVariants.map((selected: Object) => {
      if (Object.keys(selected).length < countVariants) {
        isAllSelected = false;
      }
    });

    const characteristics: any = this.product?.characteristics?.[0]?.characteristics || []
    const isJohnsonJohnson: any = Boolean(((characteristics).find((t: any) => t.slug === "manufacturer")?.values || []).find((t: any) => t.slug === "johnson-johnson"));
    const manufacturerSlug = ((characteristics || []).find((t: any) => t.slug === "manufacturer")?.values || [])?.[0]?.slug || "";

    const isNotProductStocks = await this.$api.agent.transport.get(`/delivery-term/check-available?product_id=${this.product?.id}`).then((res: any) => {
      return res?.data
    }).catch(() => {
      return false
    })
    if (isNotProductStocks) {
      const refAddToCartV2: any = this.$refs.refAddToCartV2;
      refAddToCartV2.changeIsClickAddToCart(false);

      this.$store.commit("dialog-not-avaible-notification/setOpen", {
        product: this.product,
        selectedVariants: this.selectedVariants
      });

      return
    }

    if (!isAllSelected) {
      const clientWidth: any = document.documentElement.clientWidth;

      if (clientWidth > 999) {
        // this.$customNotification.error("Необходимо выбрать опции товара");
        this.fastBuyProduct = this.product?.id || 0;
        this.fastBuyProductPayment = params?.payment;
      } else {
        this.$scrollTo(`#product-optionsScroll`, {
          offset: -80,
        })
        this.isScrolled = true;
      }

      const refAddToCartV2: any = this.$refs.refAddToCartV2;
      refAddToCartV2.changeIsClickAddToCart(false)

      return
    }

    this.$parent.$emit("changeShowDialogLoading", true);

    await Promise.all(this.selectedVariants.map(async (selected: any) => {
      const _modifications = Object.keys(selected)
        .map((key: string) => Boolean(selected[key]?.id !== -1) ? `v[${key}]=${selected[key]?.id}` : null)
        .filter((t) => !!t)
        .join('&')
      const search = `products/${this.product?.id}/modifications?${_modifications}`;
      const {data: modifications} = await this.$api.agent.transport.get(search);

      const item: IAddItemToCartBody = {
        productId: this.product?.id || 0,
        quantity: 1,
        modificationId: modifications?.[0]?.id
      };

      const response = await addToCart(item, this);
      if (!response.isSuccess) {
        isSuccessAll = false;
        const errorMessage = response?.data?.[0]?.message || response?.data?.message || "Ошибка при добавлении товара в корзину";

        let buttonLink = "";
        let buttonText = "";
        if (
          errorMessage?.indexOf('Выбрать ближайший салон') > -1 ||
          errorMessage?.indexOf('/kontakty') > -1 ||
          errorMessage?.indexOf('обратитесь в салоны оптики') > -1
        ) {
          buttonLink = "/kontakty";
          buttonText = "Адреса салонов";
        }

        this.$customNotification.error(errorMessage, {
          duration: 99999,

          buttonLink: buttonLink,
          buttonText: buttonText,
        });
      }

      this.$yandexCommerce("add", [{...this.product, ...item}])
    }));

    await this.getCart();
    await this.$store.dispatch("mindbox/productCartChange");
    this.isAddedToCart = isSuccessAll;
    if (!isSuccessAll && this.$refs.refAddToCartV2) {
      const refAddToCartV2: any = this.$refs.refAddToCartV2;

      refAddToCartV2.changeIsClickAddToCart(isSuccessAll)
    }

    this.$vkGoalWr("AddCard", {}, process.env.vkPixelCode);

    this.$parent.$emit("changeShowDialogLoading", false);

    if (params?.payment === "shares") {
      this.$store.commit("cart-new/changeSelectedPayment", "shares")
      this.$router.push("/cart");
    }
    if (params?.payment === "unitpay") {
      this.$store.commit("cart-new/changeSelectedPayment", "unitpay")
      this.$router.push("/cart");
    }
  }

  getHead() {
    this.isUrlWithId();

    return {
      title: this?.product?.seo?.title,
      meta: [
        {
          hid: "metadescription",
          name: "description",
          content: this?.product?.seo?.description || 'description',
        },
        {
          name: "keywords",
          content: this?.product?.seo?.keywords || 'keywords'
        },

        {
          hid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: getOgTitle(this?.product?.seo?.title || "og:title", this.$store.state.appState?.config),
        },
        {
          hid: "og:site_name",
          property: "og:site_name",
          content: "Linza",
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this?.product?.seo?.description || "og:description",
        },
        {
          hid: "og:image",
          property: "og:image",
          content: this.getImgPath,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: `https://${this.host}${this.product?.url}`,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: this?.product?.seo?.description || "og:description",
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content: this.getImgPath,
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: this?.product?.seo?.title || "og:title",
        },
        {
          hid: "twitter:card",
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
    };
  }

  get getImgPath() {
    const product: any = this.product;

    if (!product?.imageId) {
      return 'og:image'
    }

    return this.$img(String(product.imageId || 0), {
      width: 1000,
      format: "jpg",
    });
  }

  get productPageTopCmsPageId() {
    return this.$nuxt?.context?.env?.productPageTopCmsPageId || null
  }

  get productPageBottomCmsPageId() {
    return this.$nuxt?.context?.env?.productPageBottomCmsPageId || null
  }

  get activeSameProducts() {
    return Boolean(
      (this.product?.category?.name === 'Солнцезащитные очки' || this.product?.category?.name === 'Оправы') &&
      ((this.sameProducts || []).length > 0)
    )
  }
  get extensionsIRelatedProduct() {
    return ['characteristics']
  }

  async toCartOld(): Promise<void> {
    if (!this.modificationSelected) {
      this.$customNotification.error("Необходимо выбрать опции товара", {
        position: "top-center",
      });
      return;
    }

    const requests: Promise<any>[] = [];
    this.modifierSets.forEach((modifierSet: IModifierSet) => {
      if (modifierSet) {
        const item: IAddItemToCartBody = {
          productId: modifierSet.productId,
          quantity: 1,
          // quantity: modifierSet.quantity as number,
        };
        if (modifierSet.modifier && modifierSet.modifier.id) {
          item.modificationId = modifierSet.modifier.id as number;
        }

        addToCart(item).then((res) => {
          requests.push(res);
        }).catch((err) => {
          console.log('err: ', err.response)
        })

        // const request = new Promise((resolve, reject) => {
        //   this.putToCart(item)
        //     .then((isSuccess: boolean) => {
        //       if (isSuccess) {
        //         resolve(item);
        //         return;
        //       }
        //       reject();
        //     })
        //     .catch(reject);
        // });
        // requests.push(request);
      }
    });
    try {
      await Promise.all(requests);
      await this.getCart();

      this.isAddedToCart = true;
    } catch (e) {
      this.$customNotification.error("Ошибка добавления товара", {
        position: "top-center",
      });
    }
  }

  changeTypeEyes(typeEyes: string) {
    if (typeEyes === this.typeEyes) {
      return null;
    }

    this.typeEyes = typeEyes;

    if (typeEyes === "various") {
      this.selectedVariants.push({});
    }
    if (typeEyes === "same") {
      this.selectedVariants = [...this.selectedVariants].splice(0, 1);
    }

    (async () => {
      await this.updateProductAvailability();
    })();
  }

  isVariantSelect(modifierSet: any, variantsGroupId: any, variantId: any) {
    return Boolean(modifierSet.modifications[variantsGroupId] === variantId);
  }

  onSetVariant(
    modifierSetId: any,
    variantsGroupId: any,
    variantId: any,
    event: any
  ) {
    const dropdown = event.target?.closest(".dropdown");
    dropdown?.focus();
    dropdown?.blur();

    this.setVariant(modifierSetId, variantsGroupId, variantId);
  }

  getPrevOptionLabel(index: number, modifierSetId: number) {
    const variants = this.getVariantsForModifierSet(modifierSetId);

    return variants?.[index - 1]?.name || "";
  }

  async getRichContent() {
    if (!this.product?.id || this.cmsPageId > 0) {
      return null;
    }

    (async () => {
      await this.getProductTermInfoWithoutModification();
    })();

    // Получение страниц для контента
    const {data} = await this.$api.agent.transport.get(`products-local/${this.product?.id}/pages`).catch(() => {
      return {data: []}
    });

    if (data && data.length > 0) {
      this.cmsPageId = data[0];
    }
  }

  goBackCatalog() {
    const $cookies = this.$cookies;
    this.$cookies.set('scroll-to-product-id', String(this.product?.id));
  }

  onChangeSelected(selected: Object, idx: number) {
    let newSelectedVariants = [...this.selectedVariants];
    newSelectedVariants[idx] = selected;

    this.selectedVariants = newSelectedVariants;
    this.isAddedToCart = false;

    (async () => {
      await this.updateProductAvailability();
    })();
  }

  async updateProductAvailability() {
    const productTermDelivery: any = {};
    const productAvailability: any = {};
    const productAvailabilityAddress: any = {};
    const productAvailabilityNames: any = {};
    const productAvailabilityQuantities: any = {};
    const productPriceModifactions: any = {};
    const selected = this.selectedVariants || [];

    // Проход по наборам выбранных параметров
    await Promise.all(selected.map(async (select: any, index: number) => {

      let isAllSelected: Boolean = true;
      const countVariants: Number = this.product?.variants?.length || 0;
      if (Object.keys(select).length < countVariants) {
        isAllSelected = false;
      }

      if (this.isProductEmpty) {
        productAvailability[index] = false;
        productTermDelivery[index] = null;

        return null
      }
      if (!isAllSelected) {
        return null
      }

      const _modifications = Object.keys(select)
        .map((key: string) => Boolean(select[key]?.id !== -1) ? `v[${key}]=${select[key]?.id}` : null)
        .filter((t) => !!t)
        .join('&');
      const search = `products/${this.product?.id}/modifications?${ _modifications }&expand=stores`;
      const {data: modifications} = await this.$api.agent.transport.get(search);

      const deliveryData = await this.$api.agent.transport.get(`/delivery-term/product?product_id=${ this.product?.id }&modification_id=${modifications?.[0]?.id}`).then((res: any) => {
        return res.data
      }).catch(() => {
        return ""
      })

      productTermDelivery[index] = deliveryData;
      productAvailability[index] = Boolean((modifications?.[0]?.quantity || 0) > 0);
      productAvailabilityAddress[index] = modifications?.[0]?.stores || [];
      productAvailabilityNames[index] = modifications?.[0]?.name || [];
      productAvailabilityQuantities[index] = modifications?.[0]?.quantity || 0
      productPriceModifactions[index] = modifications?.[0]?.price || [];
    }));

    this.productTermDelivery = productTermDelivery;
    this.productAvailability = productAvailability;
    this.productAvailabilityAddress = productAvailabilityAddress;
    this.productAvailabilityNames = productAvailabilityNames;
    this.productAvailabilityQuantities = productAvailabilityQuantities;
    this.productPriceModifactions = productPriceModifactions;

    const refAddToCartV2: any = this.$refs.refAddToCartV2;
    refAddToCartV2.changeIsClickAddToCart(false)
  }

  onEmptyModification(index: number) {
    const productAvailability: any = {...this.productAvailability};

    productAvailability[index] = false;

    this.productAvailability = productAvailability;
    this.isProductEmpty = true;
  }

  openStore(store: any) {
    this.activeStore = store;
  }

  closeStore() {
    this.activeStore = {};
  }

  get extensions() {
    let items = ["files", "promotions"];

    if (this.$store.state["local-settings"].isJJ) {
      items.push("additionalCategories")
    }

    return items;
  }

  async initialProductModification() {
    const hash = this.$route?.hash || null;
    if (!hash) {
      return
    }

    const modificationId = hash.split("m=").pop();
    if (!modificationId) {
      return
    }

    const productCategory = this.product?.category.name || "";
    if (productCategory !== 'Контактные линзы') {
      return
    }

    const modificationOptions = await this.$api.agent.transport.get(`/products/${this.product?.slug}/modifications?filter[id]=${modificationId}`).then((res: any) => {
      return res.data?.[0] || null
    }).catch(() => {
      return null
    })
    if (!modificationOptions) {
      return null
    }

    const modificationVariants = modificationOptions?.variants || [];
    if (modificationVariants.length <= 0) {
      return null
    }

    let initSelected: any = {};
    modificationVariants.map((item: any) => {
      initSelected[item.group_id] = item;
    });
    this.selectedVariants = [initSelected];
    this.initSelected = initSelected;
    this.isInitSelected = true;
  }

  async loadProduct(): Promise<void> {
    const [slug] = this.$route.path.split('/').reverse();

    const requestParams: IGetProductParams = {
      slug,
      extensions: this.extensions || []
    };
    const product = await this.getProduct(requestParams);
    if (!product) {
      await this.loadProductDisabled();
      return
    }

    const isEmptyCategory = Boolean(Object.keys(product?.category || {}).length <= 0) || Boolean(String(product?.category?.id) === 'undefined');
    const isEmptyAdditionalCategories = Boolean((product?.additionalCategories || []).length <= 0);
    if (isEmptyCategory && isEmptyAdditionalCategories) {
      this.$nuxt.error({ statusCode: 404, message: `Product ${slug} not found` });
      return
    }

    this.product = JSON.parse(JSON.stringify(product));
    this.addModifierSet(product.id, 1);
  }
  async loadProductDisabled(): Promise<void> {
    const [slug] = this.$route.path.split('/').reverse();
    const catalogLink = await this.$api.agent.transport.get(`/products/${slug}/disabled-link`).then((res: any) => {
      return res?.data
    }).catch(() => {
      return null
    });
    if (!catalogLink) {
      this.$nuxt.error({ statusCode: 404, message: `Product ${slug} not found` });
      return
    }

    this.$nuxt.context.redirect(301, catalogLink);
  }

  // Получения информации о доставке для товара без модификации
  async getProductTermInfoWithoutModification (): Promise<void> {
    if (!this.product?.id || this.product.hasModifications) {
      return
    }

    const deliveryTerm = await this.$api.agent.transport.get(`/delivery-term/product?product_id=${ this.product?.id }`).then((res: any) => {
      return res.data
    }).catch(() => {
      return null
    });
    this.productTermWithoutModification = deliveryTerm;
  }


  get isVisibleRelatedProducts () {
    const isCategory = Boolean(this.product?.category?.name ==='Аксессуары' || this.product?.category?.name ==='Контактные линзы');
    const isRelatedProducts = Boolean((this.relatedProducts || []).length > 0);
    return Boolean(isCategory && isRelatedProducts)
  }

  successFastBuyProduct () {
    if (this.fastBuyProductPayment) {
      this.$store.commit("cart-new/changeSelectedPayment", this.fastBuyProductPayment)
    }
    this.$router.push("/cart");
  }


  checkVisibleMobileBuyButton(): void | null {
    const _scrollY: any = window.scrollY;
    const _windowWidth: any = window.innerWidth;
    const buyButtonElement: any = document.getElementById('addToCartInfo');
    if (!buyButtonElement) {
      return null
    }

    const rect:any = buyButtonElement.getBoundingClientRect();
    const elementTop: any = rect.top + _scrollY;

    if (_windowWidth < 999 && elementTop <= _scrollY) {
      this.isVisibleMobileBuyButton = true;
    }
    else if (_windowWidth < 999 && elementTop > _scrollY) {
      const elem = document.querySelector('.product__sticky-add-to-cart');
      elem?.classList.add('product__sticky-add-to-cart_hide');
      setTimeout(() => {
        this.isVisibleMobileBuyButton = false;
      }, 500);
    }
    else {
      this.isVisibleMobileBuyButton = false;
    }
  }
}

function VueObserveVisibility(VueObserveVisibility: any) {
  throw new Error("Function not implemented.");
}
